export * from "modules/AppointmentDetails/components/Interventions/components/Replacements/hooks/useTyreReplacementUnlinkMutation";
